/*global require*/
/**
 * Backbone Base package
 * Will add all necessary js libraries to use our custom backbone classes
 */
require(
	[
		// core
		'BaseClass',
		'BaseClassGenerator',
		// models
		'BaseModel',
		'BaseModuleModel',
		'BaseServiceModel',
		'BaseErrorModel',
		'BaseTransferModel',
		// collections
		'BaseCollection',
		'BaseServiceModelCollection',
		'BaseTransferModelCollection',
		'BaseErrorModelCollection',
		// controllers
		'BaseController',
		'BaseSettingsController',
		// views
		'BaseView',
		'BaseSettingsView'
	]
);
define("BackboneBase", function(){});

